import { render, staticRenderFns } from "./ListProductDiscount.vue?vue&type=template&id=4ff851a5&scoped=true"
import script from "./ListProductDiscount.vue?vue&type=script&lang=js"
export * from "./ListProductDiscount.vue?vue&type=script&lang=js"
import style0 from "./ListProductDiscount.vue?vue&type=style&index=0&id=4ff851a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff851a5",
  null
  
)

export default component.exports